export default __webpack_public_path__ + "static/placeholder-60c98c5e3ae1c02465031eeac5d31636.jpg";